module.exports = __webpack_public_path__ + "img/wx1.a6150c66.jpg";